import React, { Fragment } from 'react';

import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { IconButton, Box } from '@material-ui/core';

import { connect } from 'react-redux';

import projectLogo from '../../assets/images/react.svg';

const HeaderLogo = props => {
  const { sidebarToggle, sidebarHover } = props;
  return (
    <Fragment>
      <div
        className={clsx('app-header-logo app-header-logo-close', {})}>
        <Box
          className="header-logo-wrapper"
          title="Clinic Maple Leafs">
          <Link to="/" className="header-logo-wrapper-link">
            <IconButton
              color="primary"
              size="medium"
              className="header-logo-wrapper-btn">
              <img
                style={{
                  borderRadius:'50px',
                  width:'50px',
                  height:'50px'
                }}
                className="app-header-logo-img"
                alt="Clinic Maple Leafs"
                src={'http://mapleleafsclinic.com/wp-content/uploads/2015/11/maple_leafs_clinics-logo.jpg'}
              />
            </IconButton>
          </Link>
          <Box className="header-logo-text">Clinic Maple Leafs</Box>
        </Box>
      </div>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarHover: state.ThemeOptions.sidebarHover
});

export default connect(mapStateToProps)(HeaderLogo);
